package com.meistercharts.version

object MeisterChartsVersionConstants{
  val version: String = "1.39.0-SNAPSHOT"
}